import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const kinds = {
	tab: ["fandom", "cafe", "cheer"],
	category: ["all", "musician", "actor", "sportsman", "entertainer", "etc"],
	time: ["hourly", "daily", "weekly", "annually"],
	layer: ["", "category", "time", "starJoin", "rankingTip", "supportTip"]
}

export const store = new Vuex.Store({
	state: {
		tab: "fandom",
		category: "all",
		time: "hourly",
		openedLayer: "",
		magCount: 18,
	},
	mutations: {
		resetState(state) {
			state.category = "all";
			state.time = "hourly";
			state.openedLayer = "";
		},
		setTab(state, newTab) {
			if(kinds.tab.indexOf(newTab) === -1) return;
			state.tab = newTab;
			
			this.commit("resetState", state);
		},
		setCategory(state, newCategory) {
			if(kinds.category.indexOf(newCategory) === -1) return;
			state.category = newCategory;
		},
		setTime(state, newTime) {
			if(kinds.time.indexOf(newTime) === -1) return;
			state.time = newTime;
		},
		setOpenedLayer(state, newOpenedLayer) {
			if(kinds.layer.indexOf(newOpenedLayer) === -1) return;
			state.openedLayer = newOpenedLayer;
		},
		resetStarJoin(state) {
			state.starJoinCategory = "all";
			state.starJoinPage = 1;
		},
		setStarJoinCategory(state, newStarJoinCategory) {
			if(kinds.category.indexOf(newStarJoinCategory) === -1) return;
			state.starJoinCategory = payload.starJoinCategory;
		},
		setStarJoinPage(state, newStarJoinPage) {
			if(!Number.isInteger(newStarJoinPage)) return;
			state.starJoinPage = newStarJoinPage;
		}
	}
});
